const TOKEN_KEY = 'XV_ACCESS_TOKEN'
const LEGACY_TOKEN_KEY = 'ACCOUNTING_USER'
const REFRESH_KEY = 'XV_REFRESH_TOKEN'
const IMPERSONATOR_KEY = 'XV_IMPERSONATOR'

export const getAccessToken = () =>
  localStorage.getItem(TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY)

export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY)

export const setSession = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
    localStorage.removeItem(LEGACY_TOKEN_KEY)
  }

  if (refreshToken) {
    localStorage.setItem(REFRESH_KEY, refreshToken)
  }
}

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(LEGACY_TOKEN_KEY)
  localStorage.removeItem(REFRESH_KEY)
  localStorage.removeItem('drive.returnBackPath')
  sessionStorage.removeItem(IMPERSONATOR_KEY)
}

export const startImpersonation = (newToken, impersonatingEmail) => {
  const originalToken = getAccessToken()
  sessionStorage.setItem(
    IMPERSONATOR_KEY,
    JSON.stringify({ originalToken, impersonatingEmail, refreshToken: getRefreshToken() })
  )
  setSession(newToken)
}

export const getImpersonation = () => {
  try {
    return JSON.parse(sessionStorage.getItem(IMPERSONATOR_KEY) || 'null')
  } catch {
    return null
  }
}

export const endImpersonation = () => {
  const data = getImpersonation()

  if (data?.originalToken) {
    setSession(data.originalToken, data.refreshToken)
    sessionStorage.removeItem(IMPERSONATOR_KEY)
    window.location.href = '/app/users'
  }
}
